import { render, staticRenderFns } from "./notReviewTopicsDetail.vue?vue&type=template&id=b2e020e2&scoped=true&"
import script from "./notReviewTopicsDetail.vue?vue&type=script&lang=js&"
export * from "./notReviewTopicsDetail.vue?vue&type=script&lang=js&"
import style0 from "./notReviewTopicsDetail.vue?vue&type=style&index=0&id=b2e020e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e020e2",
  null
  
)

export default component.exports